(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProduct(root) {
      if (!root || root.dataset.productInitialized === 'true') return;
      root.dataset.productInitialized = 'true';

      var variantsNode = root.parentElement.querySelector('[data-product-variants]');
      var variantSelect = root.querySelector('[data-variant-select]');
      var quantityInput = root.querySelector('[data-quantity-input]');
      var addButton = root.querySelector('[data-add-to-cart]');
      var productForm = root.querySelector('.asc-product-form');
      var directCheckoutButtons = Array.prototype.slice.call(root.querySelectorAll('[data-direct-checkout-button]'));
      var checkoutError = root.querySelector('[data-checkout-error]');
      var stickyButton = document.querySelector('[data-sticky-add]');
      var stickyBar = document.querySelector('[data-sticky-bar]');
      var productPrice = root.querySelector('[data-product-price]');
      var stickyPrice = document.querySelector('[data-sticky-price]');
      var comparePrice = root.querySelector('[data-compare-price]');
      var stockStatus = root.querySelector('[data-stock-status]');
      var lowStock = root.querySelector('[data-low-stock]');
      var sku = document.querySelector('[data-current-sku]');
      var isUsed = root.dataset.isUsed === 'true';
      var hasPreorder = root.dataset.hasPreorder === 'true';
      var variants = [];

      if (variantsNode) {
        try { variants = JSON.parse(variantsNode.textContent); } catch (error) { variants = []; }
      }

      function setButtonState(button, available, availableLabel) {
        if (!button) return;
        button.disabled = !available;
        button.classList.toggle('is-disabled', !available);
        button.textContent = available ? (availableLabel || 'Add to cart') : 'Sold out';
      }

      function setDirectCheckoutState(available) {
        directCheckoutButtons.forEach(function (button) {
          setButtonState(button, available, button.dataset.availableLabel);
          button.removeAttribute('aria-busy');
        });
      }

      function selectedVariantIsAvailable() {
        if (!variantSelect) return !addButton || !addButton.disabled;
        var selectedId = String(variantSelect.value);
        var selectedVariant = variants.find(function (item) { return String(item.id) === selectedId; });
        return Boolean(selectedVariant && selectedVariant.available);
      }

      function showCheckoutError(message) {
        if (!checkoutError) return;
        checkoutError.textContent = message;
        checkoutError.hidden = false;
      }

      function clearCheckoutError() {
        if (!checkoutError) return;
        checkoutError.textContent = '';
        checkoutError.hidden = true;
      }

      async function proceedToCheckout() {
        if (!productForm || !selectedVariantIsAvailable() || productForm.dataset.checkoutBusy === 'true') return;
        if (!productForm.reportValidity()) return;
        clearCheckoutError();
        sanitizeQuantity();
        var shopRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        var formData = new FormData(productForm);
        productForm.dataset.checkoutBusy = 'true';
        directCheckoutButtons.forEach(function (button) { button.disabled = true; button.setAttribute('aria-busy','true'); });
        try {
          var response = await fetch(shopRoot + 'cart/add.js', {method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:formData});
          var data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || 'This item could not be added. Please review your cart and try again.');
          window.location.assign(shopRoot + 'checkout');
        } catch (error) {
          productForm.dataset.checkoutBusy = 'false';
          setDirectCheckoutState(selectedVariantIsAvailable());
          showCheckoutError(error.message || 'Checkout could not be opened. Please review your cart before retrying.');
        }
      }

      if (productForm) {
        productForm.addEventListener('submit', function (event) {
          var submitter = event.submitter;
          if (!submitter || !submitter.matches('[data-direct-checkout-button]')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          proceedToCheckout();
        }, true);
      }

      function sanitizeQuantity() {
        if (!quantityInput) return 1;
        var quantity = parseInt(quantityInput.value, 10) || 1;
        var max = parseInt(quantityInput.getAttribute('max'), 10);
        quantity = Math.max(1, quantity);
        if (!isNaN(max)) quantity = Math.min(max, quantity);
        quantityInput.value = quantity;
        var decrease = root.querySelector('[data-quantity-action="decrease"]');
        var increase = root.querySelector('[data-quantity-action="increase"]');
        if (decrease) decrease.disabled = quantity <= 1;
        if (increase) increase.disabled = !isNaN(max) && quantity >= max;
        return quantity;
      }

      function updateLowStock(variant) {
        if (!lowStock || !variant) return;
        var inventoryQuantity = Number(variant.inventoryQuantity);
        var shouldShow = root.dataset.isNew === 'true'
          && !hasPreorder
          && variant.available
          && variant.inventoryLimited
          && Number.isFinite(inventoryQuantity)
          && inventoryQuantity > 0
          && inventoryQuantity < 10;

        lowStock.hidden = !shouldShow;
        lowStock.textContent = shouldShow ? 'Only ' + inventoryQuantity + ' available' : '';
      }

      function updateVariant(variant) {
        if (!variant) return;
        setButtonState(addButton, variant.available);
        setButtonState(stickyButton, variant.available);
        setDirectCheckoutState(variant.available);
        clearCheckoutError();
        if (productPrice) productPrice.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;
        if (comparePrice) {
          comparePrice.hidden = !variant.hasComparePrice;
          comparePrice.textContent = variant.hasComparePrice ? variant.compareAtPrice : '';
        }
        if (stockStatus) {
          stockStatus.textContent = variant.available ? (hasPreorder ? 'Preorder' : 'In stock') : 'Sold out';
          stockStatus.classList.toggle('asc-badge--trust', variant.available && !hasPreorder);
          stockStatus.classList.toggle('asc-badge--warning', !variant.available || hasPreorder);
        }
        if (sku) sku.textContent = variant.sku || 'Not assigned';
        updateLowStock(variant);
        if (quantityInput) {
          if (variant.inventoryLimited && variant.inventoryQuantity > 0) {
            quantityInput.setAttribute('max', String(variant.inventoryQuantity));
          } else {
            quantityInput.removeAttribute('max');
          }
          quantityInput.disabled = !variant.available;
          sanitizeQuantity();
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      if (variantSelect) {
        variantSelect.addEventListener('change', function () {
          var selectedId = String(variantSelect.value);
          var variant = variants.find(function (item) { return String(item.id) === selectedId; });
          updateVariant(variant);
        });
      }

      root.querySelectorAll('[data-quantity-action]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (!quantityInput) return;
          var quantity = sanitizeQuantity();
          quantityInput.value = button.dataset.quantityAction === 'increase' ? quantity + 1 : quantity - 1;
          sanitizeQuantity();
        });
      });
      if (quantityInput) {
        quantityInput.addEventListener('change', sanitizeQuantity);
        quantityInput.addEventListener('input', sanitizeQuantity);
        sanitizeQuantity();
      }

      if (addButton && stickyBar && 'IntersectionObserver' in window) {
        var purchaseObserver = new IntersectionObserver(function (entries) {
          stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
        }, { threshold: 0.2 });
        purchaseObserver.observe(addButton);
      }

      var media = Array.prototype.slice.call(root.querySelectorAll('[data-product-media]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-product-thumb]'));
      var gallery = root.querySelector('[data-product-gallery]');
      var count = root.querySelector('[data-gallery-count]');
      var imageDialog = root.querySelector('[data-image-dialog]');
      var dialogImage = root.querySelector('[data-image-dialog-image]');
      var dialogCaption = root.querySelector('[data-image-dialog-caption]');
      var dialogClose = root.querySelector('[data-image-dialog-close]');
      var dialogOpener = null;
      var currentMedia = 0;
      var mediaRequest = 0;
      var touchStartX = 0;

      function activateMedia(index) {
        currentMedia = index;
        media.forEach(function (item, itemIndex) {
          var active = itemIndex === currentMedia;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-hidden', active ? 'false' : 'true');
          item.toggleAttribute('inert', !active);
        });
        thumbs.forEach(function (thumb, itemIndex) {
          thumb.setAttribute('aria-current', itemIndex === currentMedia ? 'true' : 'false');
        });
        if (count) count.textContent = 'Image ' + (currentMedia + 1) + ' of ' + media.length;
      }

      function showMedia(index) {
        if (!media.length) return;
        var nextMedia = (index + media.length) % media.length;
        if (nextMedia === currentMedia) return;

        var request = ++mediaRequest;
        var target = media[nextMedia];
        var targetImage = target ? target.querySelector('img') : null;

        function finish() {
          if (request !== mediaRequest) return;
          if (gallery) gallery.classList.remove('is-loading');
          activateMedia(nextMedia);
        }

        if (!targetImage || targetImage.complete) {
          finish();
          return;
        }

        if (gallery) gallery.classList.add('is-loading');
        targetImage.loading = 'eager';
        if (typeof targetImage.decode === 'function') {
          targetImage.decode().then(finish).catch(finish);
        } else {
          targetImage.addEventListener('load', finish, { once: true });
          targetImage.addEventListener('error', finish, { once: true });
        }
      }

      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () { showMedia(index); });
      });
      var previous = root.querySelector('[data-gallery-previous]');
      var next = root.querySelector('[data-gallery-next]');
      if (previous) previous.addEventListener('click', function () { showMedia(currentMedia - 1); });
      if (next) next.addEventListener('click', function () { showMedia(currentMedia + 1); });
      if (gallery && media.length > 1) {
        gallery.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') showMedia(currentMedia - 1);
          if (event.key === 'ArrowRight') showMedia(currentMedia + 1);
        });
        gallery.addEventListener('touchstart', function (event) { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
        gallery.addEventListener('touchend', function (event) {
          var distance = event.changedTouches[0].clientX - touchStartX;
          if (Math.abs(distance) < 45) return;
          showMedia(distance > 0 ? currentMedia - 1 : currentMedia + 1);
        }, { passive: true });
      }

      root.querySelectorAll('[data-open-image]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (!imageDialog || !dialogImage) return;
          dialogOpener = button;
          dialogImage.src = button.dataset.imageSrc || '';
          dialogImage.alt = button.dataset.imageAlt || '';
          if (dialogCaption) dialogCaption.textContent = button.dataset.imageCaption || '';
          if (typeof imageDialog.showModal === 'function') {
            imageDialog.showModal();
          } else {
            imageDialog.setAttribute('open', '');
          }
        });
      });

      function closeImageDialog() {
        if (!imageDialog) return;
        if (typeof imageDialog.close === 'function') {
          imageDialog.close();
        } else {
          imageDialog.removeAttribute('open');
        }
      }

      if (dialogClose) dialogClose.addEventListener('click', closeImageDialog);
      if (imageDialog) {
        imageDialog.addEventListener('click', function (event) {
          if (event.target === imageDialog) closeImageDialog();
        });
        imageDialog.addEventListener('close', function () {
          if (dialogOpener) dialogOpener.focus();
        });
      }
    }

    function initAllProducts() {
      document.querySelectorAll('[data-product-root]').forEach(initProduct);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllProducts, { once: true });
    } else {
      initAllProducts();
    }
    document.addEventListener('shopify:section:load', initAllProducts);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-countdown-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shopforge-countdown')) {
    customElements.define('shopforge-countdown', class extends HTMLElement {
      connectedCallback() {
        const target = Date.parse(this.dataset.end || '');
        const output = this.querySelector('[data-countdown-output]');
        if (!output || Number.isNaN(target)) return;
        const render = () => {
          const distance = Math.max(0, target - Date.now());
          const days = Math.floor(distance / 86400000);
          const hours = Math.floor((distance % 86400000) / 3600000);
          const minutes = Math.floor((distance % 3600000) / 60000);
          output.textContent = distance ? `${days}d ${hours}h ${minutes}m` : 'Now available';
          if (!distance && this.timer) window.clearInterval(this.timer);
        };
        render();
        this.timer = window.setInterval(render, 60000);
      }
      disconnectedCallback() { if (this.timer) window.clearInterval(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
